import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { UnionFragment } from '@amf/shared/types/graphql';

import JoinPlayerForm, { JoinPlayerFormData } from 'components/join/JoinPlayerForm';

const defaultValues: JoinPlayerFormData = {
  name: '',
  email: '',
  phone: '',
  foreign: false,
  union: '',
  note: null,
  identification: '',
};

interface JoinPlayerSendProps {
  unions: UnionFragment[];
}

function JoinPlayerSend({ unions }: JoinPlayerSendProps) {
  const { t } = useTranslate('malyfotbal');
  const [error, setError] = useState<Error | undefined>(undefined);
  const [success, setSuccess] = useState(false);

  const send = async (data: JoinPlayerFormData) => {
    setError(undefined);
    setSuccess(false);

    const response = await fetch('/api/join/player', {
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      setError(new Error(result.error));
      return;
    }

    if (result.success) {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className='Form Form--center'>
        <h2>{t('join.player.form.success.title')}</h2>
        <p className='Form__message'>{t('join.player.form.success.message')}</p>
      </div>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      {error && <p>{error}</p>}
      <JoinPlayerForm onSubmit={send} values={defaultValues} unions={unions} />
    </GoogleReCaptchaProvider>
  );
}

export default JoinPlayerSend;
